<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Edit Manager</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <p>
      Name:
      <a [routerLink]="['/customers', associationManager.customer_id.toString()]" target="_blank">
        {{ associationManager.customer_first_name }} {{ associationManager.customer_last_name }}
      </a>
      <br>
      Date Added: {{ dateStringFromISO8601(associationManager.created_at) }}
    </p>

    <div class="alert alert-danger" role="alert" *ngIf="errors.non_field_errors">
      {{ errors.non_field_errors }}
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-danger"
            (click)="handleRemove()"
            [disabled]="loadingSubmit"
            [class.disabled]="loadingSubmit">
      {{ loadingSubmit ? 'Loading...' : 'Remove Manager' }}
    </button>
  </div>

</ng-container>
